import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged,
  sendEmailVerification,
  GoogleAuthProvider,
  signInWithPopup
} from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBzc7_6rKx7M3wBRqSoBglJpAdlIX_SUyQ",
  authDomain: "lawra-ai.firebaseapp.com",
  projectId: "lawra-ai",
  storageBucket: "lawra-ai.firebasestorage.app",
  messagingSenderId: "241741683624",
  appId: "1:241741683624:web:1c526bf74b15fef9569b9d",
  measurementId: "G-WJDNQSGD7Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Google Auth Provider
const googleProvider = new GoogleAuthProvider();

export { 
  auth, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged,
  sendEmailVerification,
  googleProvider,
  signInWithPopup
};
